// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"372":"cb65caf3f89e30b5","527":"06e235e9e1a05319"}[chunkId] + ".js";
};